import Styles from './Carousels.module.scss'
import { SectionHeader } from './SectionHeader'
import { useUploads } from 'components/Design/UploadsTab/useUploads'
import { collectResults } from 'utils/query'
import { getMediaFiles } from 'components/Design/UploadsTab/getMediaFiles'
import { MediaFileCarousel } from './MediaFileCarousel'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { UploadedMediaCarouselProps } from '../Types'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { UploadsDrawer } from '../Grids/UploadsDrawer'
import { useMediaPickerContext } from '../MediaPickerContext'

const title = 'Uploaded Media'

export const Uploads = observer(({ accept }: UploadedMediaCarouselProps) => {
  const { openDrawer } = useRootStore().drawersStore
  const { handleSelect } = useMediaPickerContext()
  const uploadsQuery = useUploads()
  const uploads = collectResults(uploadsQuery, (data) => data.files)
  const mediaFiles = getMediaFiles(uploads, accept)

  const openUploadsDrawer = () => {
    openDrawer(UploadsDrawer, { title, accept, onSelect: handleSelect })
  }

  if (uploadsQuery.isFetched && !mediaFiles.length) return null

  return (
    <MobileWizard.Section gap={8}>
      <SectionHeader title={title} onPress={openUploadsDrawer} />
      <div className={Styles.sectionContainer}>
        <MediaFileCarousel mediaFiles={mediaFiles} isLoading={uploadsQuery.isLoading} provider="uploads" />
      </div>
    </MobileWizard.Section>
  )
})
